import axios from "axios";


class CsrfTokenManager {
    constructor() {
        this._token = null;
        this._refreshPromise = null;
        this._updateQueue = Promise.resolve();
    }


    async getToken() {
        if (this._token) return this._token;
        return this.refreshToken();
    }

    async refreshToken() {
        if (!this._refreshPromise) {
            this._refreshPromise = (async () => {
                try {
                    const response = await axios.get('/csrf-token', {
                        headers: {
                            'Accept': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    });

                    if (response.data?.csrfToken) {
                        await this.updateFromResponse(response.data.csrfToken);
                    }

                    return this._token;
                } finally {
                    this._refreshPromise = null;
                }
            })();
        }
        return this._refreshPromise;
    }

    async updateFromResponse(token) {
        // Queue token updates to prevent race conditions
        this._updateQueue = this._updateQueue.then(async () => {
            if (token) {
                this._token = token;
                this._updateTokenInDOM();

                // Also update axios default headers
                axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
            }
        });
        return this._updateQueue;
    }

    _updateTokenInDOM() {
        if (!this._token) return;

        // Update meta tag
        const meta = document.head.querySelector('meta[name="csrf-token"]');
        if (meta) {
            meta.content = this._token;
        }
    }
}

export const csrfTokenManager = new CsrfTokenManager();
